import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAnnouncementsHeader } from "store/announcementSlice";

function getActiveList(headerData) {
  if (!headerData) return [];
  let raw = Array.isArray(headerData)
    ? headerData
    : headerData?.data ?? headerData?.announcements ?? [];
  if (!Array.isArray(raw) && raw && typeof raw === "object") {
    raw = raw.data ?? raw.announcements ?? raw.list ?? [];
  }
  const list = Array.isArray(raw) ? raw : [];
  return list.filter((item) => item && item.isActive === true);
}

function AnnouncementCard({ item, cardWidthPercent }) {
  return (
    <div
      className="flex flex-shrink-0 items-center justify-center px-5 py-[4px] text-center text-base font-medium"
      style={{
        backgroundColor: item.backgroundColor || "#000000",
        color: item.textColor || "#ffffff",
        width: `${cardWidthPercent}%`,
      }}
    >
      <span className="break-words">{item.message}</span>
    </div>
  );
}

export default function ActiveAnnouncementBanner() {
  const dispatch = useDispatch();
  const { headerData } = useSelector((state) => state.announcements);

  const list = useMemo(() => getActiveList(headerData), [headerData]);

  useEffect(() => {
    dispatch(getAnnouncementsHeader({ isActive: true, limit: 20 }));
  }, [dispatch]);

  if (!list.length) return null;

  // One card = 100% of container; track has 2 copies for infinite scroll
  const totalSlides = list.length * 2;
  const cardWidthPercent = 100 / totalSlides;
  // Same time per card regardless of count (e.g. 5 seconds per card)
  const SECONDS_PER_CARD = 16;
  const animationDuration = list.length * SECONDS_PER_CARD;

  return (
    <>
      <style>{`
        @keyframes announcement-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .announcement-carousel-track {
          will-change: transform;
        }
      `}</style>
      <div className="sticky top-0 z-50 w-full shrink-0 overflow-hidden">
        <div
          className="announcement-carousel-track flex"
          style={{
            width: `${totalSlides * 100}%`,
            animation: `announcement-scroll ${animationDuration}s linear infinite`,
          }}
        >
          {[...list, ...list].map((item, index) => (
            <AnnouncementCard
              key={index < list.length ? item._id : `dup-${item._id}`}
              item={item}
              cardWidthPercent={cardWidthPercent}
            />
          ))}
        </div>
      </div>
    </>
  );
}
